import React, { useContext } from 'react'
import { MainNotificationContext, applicationConfiguration } from '../shared'
import { useModal } from 'app/components/modal'
import FeedbackModalBody from './feedback-modal-body'
import { useTypedTranslation } from '../shared/hooks/use-translation'
import { AuthContext } from '../auth'
import Button from 'app/modules/shared/components/button'

const ProductFeedback = () => {
  const mainNotification = useContext(MainNotificationContext)
  const { _t } = useTypedTranslation()
  const config = useContext(applicationConfiguration)
  const auth = useContext(AuthContext)
  const isCommunity = config.buildType === 'community'
  const isLoggedIn = !!auth.user
  const [openModal, hideModal] = useModal()

  const handleSubmit = (canSubmit: boolean) => {
    if (canSubmit) {
      mainNotification.setMessageData(_t('thank-you-for-your-feedback'), 'success', 3000)
    } else {
      mainNotification.setMessageData(_t('you-have-already-submitted-feedback'), 'danger', 3000)
    }
    hideModal()
  }

  const openFeedbackModal = () => {
    openModal({
      title: _t('give-feedback'),
      body: <FeedbackModalBody hideModal={hideModal} onSubmit={handleSubmit} />,
      props: {
        dialogClassName: 'modal-size-auto',
        onHide: hideModal,
      },
    })
  }

  if (!isCommunity || !isLoggedIn) {
    return null
  }

  return (
    <Button id="product-feedback-open-modal" variant="tertiary" className="btn-link-style" onClick={openFeedbackModal}>
      {_t('feedback')}
    </Button>
  )
}

export default ProductFeedback
